import { render, staticRenderFns } from "./KworbChart.vue?vue&type=template&id=959bbc82&"
import script from "./KworbChart.vue?vue&type=script&lang=js&"
export * from "./KworbChart.vue?vue&type=script&lang=js&"
import style0 from "./KworbChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports